module.exports = __webpack_public_path__ + "img/ic_room_customer_right_img2.c81e8716.png";